module.exports = __webpack_public_path__ + "static/media/激光切割尤克里里.40615136.png";